import { FunctionalComponent, nextTick, ref } from 'vue'
import { useEffect, useHOC, useState } from '@pe-h5pages-fe/journey/src/pages/journey/hook'
import { match } from '@/utils/match'
import Spin from '../spin'
import Empty from '../empty'
import styles from './styles.module.scss'
import classNames from 'classnames'
import { Sticky } from 'vant'
import Tracker from '@nio-fe/nio-tracker-web'
import { SearchListItemModel } from './searchList.model'
import { FilterItem, FilterKey, FilterState } from '../filter/filter.model'
import { getResourceIconByType } from '../../utils/icon'
import { getPowerResourceTypeV2 } from '@/pages/chargermap/utils/resource'
import { useComponentStore } from '../../nsh5/localStores/component'
import { PointType } from '../../contract/map'

export type ListProps = {
  dataSourcePois?: SearchListItemModel[] | null
  dataSourceNioStore?: SearchListItemModel[] | null
  dataSourceTestDrive?: SearchListItemModel[] | null
  dataSourceServiceCenter?: SearchListItemModel[] | null
  dataSourceRecharge?: SearchListItemModel[] | null
  dataSourceRechargePS?: SearchListItemModel[] | null
  dataSourceRechargeCS?: SearchListItemModel[] | null
  keyword?: string
  loading?: boolean
  onItemClick?: (index: number, itemType: string) => void
  fixed?: boolean // 全部 地点 资源 是否固定
  onTabClick?: () => void
}

export interface ITabItem {
  text: string
  type: number
  show: boolean
  key: string
}
const List: FunctionalComponent<ListProps> = (props) => {
  const componentStore = useComponentStore()
  const initTabs: ITabItem[] = [
    {
      text: '全部',
      type: 0,
      show: true,
      key: 'all',
    },
    {
      text: '地点',
      type: 1,
      show: true,
      key: 'poi',
    },
  ]
  const reservedTabs: ITabItem[] = [
    {
      text: componentStore.filterNameMap.test_drive,
      type: 2,
      show: false,
      key: 'test_drive',
    },
    {
      text: componentStore.filterNameMap.nio_store,
      type: 3,
      show: false,
      key: 'nio_store',
    },
    {
      text: componentStore.filterNameMap.service_center,
      type: 4,
      show: false,
      key: 'service_center',
    },
    {
      text: componentStore.filterNameMap['recharge|ps'],
      type: 5,
      show: false,
      key: 'recharge|ps',
    },
    {
      text: componentStore.filterNameMap['recharge|cs'],
      type: 6,
      show: false,
      key: 'recharge|cs',
    },
  ]
  reservedTabs.sort((a, b) => {
    // 排序
    const order = componentStore.filter.map((val) => val.key)
    return order.indexOf(a.key) - order.indexOf(b.key)
  })
  const tabs: ITabItem[] = initTabs.concat(reservedTabs)
  const tabRefs = ref<HTMLElement[]>([])
  const [state, setState] = useState({
    activeTab: 0,
  })
  const {
    dataSourcePois: listPois,
    dataSourceTestDrive: listTestDrive,
    dataSourceNioStore: listNioStore,
    dataSourceServiceCenter: listServiceCenter,
    dataSourceRecharge: listRecharge,
    dataSourceRechargePS: listRechargePS,
    dataSourceRechargeCS: listRechargeCS,
    loading = false,
    fixed = false,
  } = props

  const handleSelect = (index: number, itemType: string) => {
    props?.onItemClick?.(index, itemType)
  }

  const highlightRender = (str: string) => {
    if (!props.keyword) {
      return str
    }
    const parts = match(str, `${props.keyword}`)
    return parts.map((val) => {
      if (typeof val === 'string') {
        return val
      }
      if (typeof val === 'object') {
        return <em>{val.join('')}</em>
      }
    })
  }

  const handleTabClick = (type: number) => {
    props?.onTabClick?.()
    setState((state) => ({ ...state, activeTab: type }))
    const scrolllistWrapper = document.getElementById('routesScrollWrapper')
    scrolllistWrapper?.scrollIntoView(true)
    nextTick(() => {
      const scrollWrapper = document.getElementById('suggestsScrollWrapper')
      if (scrollWrapper) {
        scrollWrapper!.scrollTop = 0
      }
    })
    // 让当前选中的 tab 滚动到容器的最左侧
    const currentTab = tabRefs.value[type]
    if (currentTab) {
      currentTab.scrollIntoView({
        behavior: 'smooth', // 平滑滚动
        inline: 'start', // 对齐容器左侧
        block: 'nearest', // 避免垂直方向滚动
      })
    }
    Tracker.track(
      'nsh5_searchtabclick',
      Object.assign(
        {},
        {
          channel: window.channel,
          client: window.client,
          brand: (process.config as any).brand,
          screen_orientation: window.screen_orientation,
          view_mode: componentStore.viewMode,
          container: window.container,
          user_identity: window.user_identity,
          trigger: 'click',
          element: '首页搜索列表-搜索项tab切换',
          page_source: window.page_source,
        },
        { tab_name: tabs[type].text }
      )
    )
  }

  const tabRender = () => {
    const componentStore = useComponentStore()
    componentStore.filter.forEach((item: FilterItem) => {
      const index = tabs.findIndex((tab) => tab.key === item.key)
      if (index !== -1) {
        tabs[index].show = item.filterState === FilterState.On
      }
    })
    const node = (
      <>
        <div class={classNames([styles.tabBox, fixed ? styles.tabBoxFixed : null])}>
          {tabs
            .filter((a) => a.show)
            .map(({ text, type }) => (
              <div
                ref={(el) => (tabRefs.value[type] = el as HTMLElement)}
                class={classNames(styles.tabItem, {
                  [styles.selected]: activeTab === type,
                })}
                onClick={() => handleTabClick(type)}
              >
                {text}
              </div>
            ))}
        </div>
      </>
    )
    return fixed ? (
      <Sticky class={classNames(styles.fixedSticky)} offsetTop={206}>
        {node}
      </Sticky>
    ) : (
      node
    )
  }

  const suggestsRender = (renderType: string) => {
    let renderList: SearchListItemModel[] = []
    let desc = ''
    let type = 0
    switch (renderType) {
      case PointType.Poi:
        renderList = (listPois || []) as SearchListItemModel[]
        desc = '地点'
        type = 1
        break
      case PointType.TestDrive:
        renderList = (listTestDrive || []) as SearchListItemModel[]
        desc = componentStore.filterNameMap.test_drive
        type = 2
        break
      case FilterKey.NioStore:
        renderList = (listNioStore || []) as SearchListItemModel[]
        desc = componentStore.filterNameMap.nio_store
        type = 3
        break
      case PointType.ServiceCenter:
        renderList = (listServiceCenter || []) as SearchListItemModel[]
        desc = componentStore.filterNameMap.service_center
        type = 4
        break
      case PointType.RechargePS:
        renderList = (listRechargePS || []) as SearchListItemModel[]
        desc = componentStore.filterNameMap['recharge|ps']
        type = 5
        break
      case PointType.RechargeCS:
        renderList = (listRechargeCS || []) as SearchListItemModel[]
        desc = componentStore.filterNameMap['recharge|cs']
        type = 6
        break

      default:
        break
    }
    const renderListTemp =
      activeTab == 0 ? renderList?.filter((item, index) => index < 4) : renderList
    if (renderList?.length) {
      return (
        <>
          {activeTab == 0 ? (
            <div class={styles.desc} onClick={() => handleTabClick(type)}>
              <span>
                {desc} （{renderList?.length || 0}）
              </span>
              <ns-icon name="arrow-right-outline" color="#040B29" size="14" />
            </div>
          ) : null}
          <div class={styles.itemContainer}>
            {renderListTemp?.map((item, index) => (
              <div class={styles.item} onClick={() => handleSelect(index, renderType)}>
                <div>{getResourceIconByType(getPowerResourceTypeV2(item))}</div>
                <div>
                  <div class={styles.name}>{highlightRender(item.name)}</div>
                  <div class={styles.addr}>{highlightRender(item.address)}</div>
                </div>
              </div>
            ))}
          </div>
        </>
      )
    } else if (activeTab != 0) {
      return (
        <div class={[styles.spinContainer, styles.emptyList]}>
          <Empty tips="暂无相关结果" />
        </div>
      )
    }
  }

  const listRender = () => {
    if (
      (!listPois || listPois?.length < 1) &&
      (!listTestDrive || listTestDrive?.length < 1) &&
      (!listNioStore || listNioStore?.length < 1) &&
      (!listServiceCenter || listServiceCenter?.length < 1) &&
      (!listRecharge || listRecharge?.length < 1) &&
      (!listRechargePS || listRechargePS?.length < 1) &&
      (!listRechargeCS || listRechargeCS?.length < 1)
    ) {
      return null
    }
    const listOrder = reservedTabs
      .map((tab) => {
        switch (tab.type) {
          case 2:
            return activeTab == 0 || activeTab == 2 ? suggestsRender(PointType.TestDrive) : null
          case 3:
            return activeTab == 0 || activeTab == 3 ? suggestsRender(PointType.NioStore) : null
          case 4:
            return activeTab == 0 || activeTab == 4 ? suggestsRender(PointType.ServiceCenter) : null
          case 5:
            return activeTab == 0 || activeTab == 5 ? suggestsRender(PointType.RechargePS) : null
          case 6:
            return activeTab == 0 || activeTab == 6 ? suggestsRender(PointType.RechargeCS) : null

          default:
            break
        }
      })
      .filter((item) => item)

    return (
      <>
        <div class={styles.listWrapper}>
          {tabRender()}
          <div class={classNames(styles.suggests)} id="suggestsScrollWrapper">
            {activeTab == 0 || activeTab == 1 ? suggestsRender(PointType.Poi) : null}
            {listOrder.map((tab) => {
              return tab
            })}
          </div>
        </div>
      </>
    )
  }

  const { activeTab } = state

  useEffect(() => {
    if (props.loading) {
      setState((state) => ({ ...state, activeTab: 0 }))
    }
  }, [props.loading])

  return (
    <div
      class={[
        ...(listPois?.length !== 0 ||
        listTestDrive?.length !== 0 ||
        listNioStore?.length !== 0 ||
        listServiceCenter?.length !== 0 ||
        listRecharge?.length !== 0 ||
        listRechargePS?.length !== 0 ||
        listRechargeCS?.length !== 0
          ? [styles.list]
          : [styles.empty]),
      ].join(' ')}
    >
      {loading && (
        <div class={styles.spinContainer}>
          <Spin spinning={loading} tip={'搜索中'}></Spin>
        </div>
      )}

      {loading === false &&
      listPois === undefined &&
      listTestDrive === undefined &&
      listNioStore === undefined &&
      listServiceCenter === undefined &&
      listRecharge === undefined &&
      listRechargePS === undefined &&
      listRechargeCS === undefined ? (
        <div class={[styles.spinContainer, styles.emptyList]}>
          <Empty tips="暂无相关结果" />
        </div>
      ) : null}
      {listRender()}
    </div>
  )
}

List.displayName = 'List' // 首页list

export default useHOC(List)
